import type * as Types from '@formic/fusion-graphql/schema';

import type { ProjectScreenOptionsFragment } from './Projects/Projects.gql';
import { gql } from 'urql';
import { ProjectScreenOptionsFragmentDoc } from './Projects/Projects.gql';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type HomeScreenOptionsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type HomeScreenOptionsQuery = {
  onlineFormsOptions: {
    loginEnabled: boolean;
    registrationEnabled: boolean;
  } & ProjectScreenOptionsFragment;
};

export const HomeScreenOptionsDocument = /*#__PURE__*/ gql`
  query homeScreenOptions {
    onlineFormsOptions {
      loginEnabled
      registrationEnabled
      ...ProjectScreenOptions
    }
  }
  ${ProjectScreenOptionsFragmentDoc}
`;

export function useHomeScreenOptionsQuery(
  options: Omit<Urql.UseQueryArgs<HomeScreenOptionsQueryVariables>, 'query'> = {},
) {
  return Urql.useQuery<HomeScreenOptionsQuery>({ query: HomeScreenOptionsDocument, ...options });
}
